// import useSound from "use-sound";

export const ENDPOINT = "transport-document";
export enum TransportDocumentQueryKey {
  GetOne = "get-one-transport-document",
  GetAll = "get-all-transport-documents",
  GetLoad = "get-loaded-transport-documents",
  GetAllByCustomer = "get-all-transport-documents-by-customer",
  GetNotReportedToNv = "get-td-not-reported-to-nv",
}

export type FinalEmailDTO = {
  id: number;
  payload: {
    toCustomer: boolean;
    toWasteStation: boolean;
    toParentCustomer: boolean;
  };
};

export enum RapporteringsTyp {
  Transport = "Transport",
  OmbudsRapportering = "TransportPlanering",
}

export type NotReportedToEnvType = {
  tdId: number;
  transportDate: string;
  customerName: string;
  type: RapporteringsTyp;
  itemId: string;
  wasteStationName: string;
};
